import moment from "moment";
import * as yup from "yup";

export const validationSchema = yup.object().shape({
  subscribers: yup.array().min(1, "Reminders need to have at least one subscriber."),
  comment: yup.string(),
  is_today_selected: yup.bool(),
  send_on: yup.number().required(),
  send_at: yup
    .string()
    .required()
    .test("is-in-past", "Time must be in the future", function (value) {
      const { is_today_selected, relative_unit } = this.parent;

      if (relative_unit !== "day") {
        return true;
      }

      if (is_today_selected) {
        const selectedTime = moment(`${moment().format("YYYY-MM-DD")} ${value}:00`);
        const min = moment().startOf("minute").add(5, "minutes");
        const minutes = min.minutes();
        const roundedMinutes = Math.ceil(minutes / 5) * 5;

        if (roundedMinutes === 60) {
          min.add(1, "hour").minutes(0);
        } else {
          min.minutes(roundedMinutes);
        }

        return selectedTime.isSameOrAfter(min);
      }

      return true;
    }),
  is_relative: yup.bool().nullable(),
  relative_unit: yup.string().nullable(),
  relative_value: yup.number().nullable(),
  relative_value_modifier: yup.number().nullable(),
});
